// Shopify Add to Cart Time Restriction Script
// Store open 10:45 AM to 10:00 PM (22:00), Europe/Bucharest
// Add to cart is disabled outside these hours

(function() {
  'use strict';

  const CONFIG = {
    timezone: 'Europe/Bucharest',
    openHour: 10,
    openMinute: 45,
    closeHour: 22,
    closeMinute: 0,
    buttonSelectors: [
      'button[name="add"]',
      '.product-form__submit',
      '.add-to-cart',
      '#AddToCart',
      'button.btn--add-to-cart',
      '[data-add-to-cart]',
      '[data-ocu-checkout="true"]',
      'button[name="checkout"]'
    ],
    formSelectors: [
      'form[action*="/cart/add"]',
      '.product-form',
      '[data-product-form]'
    ],
    linkSelectors: [
      '.m-cart-drawer__link-to-cart'
    ]
  };

  function isStoreOpen() {
    const now = new Date();
    const bucharestTime = new Date(now.toLocaleString('en-US', { timeZone: CONFIG.timezone }));
    const currentMinutes = bucharestTime.getHours() * 60 + bucharestTime.getMinutes();
    const openMinutes = CONFIG.openHour * 60 + CONFIG.openMinute;
    const closeMinutes = CONFIG.closeHour * 60 + CONFIG.closeMinute;

    // Handles both same-day windows (e.g. 10:45-22:00) and overnight windows
    // (e.g. if you ever set open > close, like 22:00-09:00) automatically.
    if (openMinutes < closeMinutes) {
      return currentMinutes >= openMinutes && currentMinutes < closeMinutes;
    } else {
      return currentMinutes >= openMinutes || currentMinutes < closeMinutes;
    }
  }

  function blockEvent(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    return false;
  }

  function disableAddToCart() {
    // Disable buttons
    CONFIG.buttonSelectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(button => {
        if (button.hasAttribute('data-hours-disabled')) return;

        button.disabled = true;
        button.style.opacity = '0.5';
        button.style.cursor = 'not-allowed';
        button.style.pointerEvents = 'none';
        button.setAttribute('data-hours-disabled', 'true');
        button.textContent = 'Restaurant închis';

        button.addEventListener('click', blockEvent, true);
      });
    });

    // Block form submissions
    CONFIG.formSelectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(form => {
        if (form.hasAttribute('data-hours-disabled')) return;

        form.setAttribute('data-hours-disabled', 'true');
        form.addEventListener('submit', blockEvent, true);
      });
    });

    // Hide links (e.g. "view cart"). Anchor tags have no `disabled` attribute,
    // so we hide them outright and block clicks as a fallback.
    CONFIG.linkSelectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(link => {
        if (link.hasAttribute('data-hours-disabled')) return;

        link.setAttribute('data-hours-disabled', 'true');
        link.style.display = 'none';
        link.addEventListener('click', blockEvent, true);
      });
    });
  }

  function init() {
    if (!isStoreOpen()) {
      disableAddToCart();

      new MutationObserver(() => {
        if (!isStoreOpen()) disableAddToCart();
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  setInterval(() => {
    if (!isStoreOpen()) disableAddToCart();
    else location.reload();
  }, 60000);

})();